import { CC_PRIMARY } from "./brand-primitives";

const dialogTitleStyle = {
  fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
  fontSize: 20,
  fontWeight: 400,
  textAlign: "center",
};

const subHeadingStyle = {
  fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
  fontSize: 16,
  fontWeight: 300,
  textAlign: "center",
  padding: 10,
};

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
  textAlign: "center",
};

const boxStyleNoPadding = {
  ...boxStyle,
  padding: 0,
  borderRadius: "10px",
};

const largeBoxStyleNoPadding = {
  ...boxStyleNoPadding,
  width: 504,
};

const gettingStartedBoxStyle = {
  ...boxStyleNoPadding,
  width: "fit-content",
  outline: 0
}

const createContentBoxStyle = {
  ...gettingStartedBoxStyle, 
  left: "53%",
}

const createContentBoxMobile = {
  ...createContentBoxStyle,
  left: "50%",
  borderRadius: "0px",
}

const arrowBoxStyle = {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    "&::before": {
      backgroundColor: "white",
      content: '""',
      display: "block",
      position: "absolute",
      width: 14,
      height: 14,
      top: -7,
      transform: "rotate(45deg)",
      left: "calc(100% - 56px)",
    }
};

const arrowBoxStyleBottom = {
  ...arrowBoxStyle,
  "&::before": {
    top: 72,
  },
};

const postStatusTreyBoxStyle = {
  width: 485,
  minHeight: 80,
  maxHeight: 600,
  borderRadius: 2,
  backgroundColor: "white",
  padding: "10px",
  boxShadow: 2,
};

const postStatusTreyBoxStyleBottom = {
  ...postStatusTreyBoxStyle,
  mr: "72px",
};

const postBar = {
  display: "flex",
  width: "100%",
  height: 8,
  borderRadius: "4px",
  overflow: "hidden",
};

const postProgressBar = {
  backgroundImage:
    `repeating-linear-gradient(45deg, ${CC_PRIMARY[100]}, ${CC_PRIMARY[100]} 4px, ${CC_PRIMARY[500]} 4px, ${CC_PRIMARY[500]} 8px)`,
};

const genericModalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: "1em",
  borderRadius: "5px",
  textAlign: "center",
  boxShadow: "4px 4px 8px 0px #DEE1F7",
}

export {
  dialogTitleStyle,
  subHeadingStyle,
  boxStyle,
  arrowBoxStyle,
  postStatusTreyBoxStyle,
  postBar,
  postProgressBar,
  boxStyleNoPadding,
  largeBoxStyleNoPadding,
  arrowBoxStyleBottom,
  postStatusTreyBoxStyleBottom,
  gettingStartedBoxStyle,
  createContentBoxStyle,
  createContentBoxMobile,
  genericModalBoxStyle
};
